import { Divider, Grid, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Error from "./Error";
import Avatar from "@mui/material/Avatar";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import YoutubeEmbed from "./YoutubeEmbed";

export default function Payment() {
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    // Check if user data is available from Firebase Auth
    if (currentUser) {
      setLoading(false);
    } else {
      setError("User not authenticated");
      setLoading(false);
    }
  }, [currentUser]);

  return error ? (
    <Error message={error} solution="Please login again to access this page." />
  ) : loading ? (
    <Box sx={{ display: "block", textAlign: "center", marginTop: "100px" }}>
      <CircularProgress />
    </Box>
  ) : (
    <Box className="dashboard-gl">
      <Box className="dashboard-card">
        <Typography
          variant="h2"
          sx={{ color: "white", marginBottom: "13px", textAlign: "center" }}
        >
          Payment Details
        </Typography>

        <Box sx={{ padding: "20px", textAlign: "center" }}>
          <Typography variant="h5" sx={{ color: "white" }}>
            🚧 Payment is not started yet. Please check back later.
          </Typography>
        </Box>

        {/* <div className="dashboard-card">
          <Divider light={true} />

          <ul>
            <li>
              Watch these instructions carefully before making any payment.
            </li>
          </ul>
          <br />

          <div className="youtube-div-center">
            <YoutubeEmbed embedId="https://drive.google.com/file/d/1bCUPz9nj1VgjodbrdswOAyWwNAKvsLbO/preview" />
          </div>

          <div className="text-center-payment" style={{ margin: "10px" }}>
            <button
              className="button-5"
              style={{ whiteSpace: "nowrap", padding: "10px" }}
            >
              <a
                href="https://docs.google.com/document/d/1u_ff7V5uYch6rFaNaWORXGxA8EjK_iuhQTJfXJ1MiVo/edit?usp=sharing"
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: "none" }}
              >
                Read these instructions <br /> before making payment.
              </a>
            </button>
          </div>

          <div className="text-center-payment" style={{ margin: "10px" }}>
            <button className="button-5">
              <a
                href="https://www.onlinesbi.sbi/sbicollect/icollecthome.htm"
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: "none" }}
              >
                Make Payment
              </a>
            </button>
          </div>

        </div> */}
      </Box>
    </Box>
  );
}
